import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { Input, Text, TextInput, Select, Button, Loader } from "@mantine/core";
import { withAuthenticator } from "@aws-amplify/ui-react";
import { useMediaQuery } from "@mantine/hooks";

function BillingsData({ user }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address, setAddress] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");

  const [updateProfile, setUpdateProfile] = useState(false);
  const [personalOrCompany, setPersonalOrCompany] = useState("personal");
  const [iban, setIban] = useState("");
  const [bicSwift, setBicSwift] = useState("");
  const [idDocumentation, setIdDocumentation] = useState("");
  const [personalIdentificationNumber, setPersonalIdentificationNumber] =
    useState("");
  const [identityCardNumber, setIdentityCardNumber] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(0);
  const [visible, setVisible] = useState(false);
  const [changes, setChanges] = useState(false);

  const matches = useMediaQuery("(min-width: 800px)");

  useEffect(() => {
    axios
      .post(
        "https://17eh5s1nff.execute-api.eu-north-1.amazonaws.com/doglass/",
        {},
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        if (res.data.billing_data.length != 0) {
          setFirstName(res.data.billing_data[0].first_name);
          setLastName(res.data.billing_data[0].last_name);
          setDateOfBirth(res.data.billing_data[0].date_of_birth);
          setAddress(res.data.billing_data[0].address);
          setIban(res.data.billing_data[0].iban);
          setBicSwift(res.data.billing_data[0].bic_swift);
          setIdentityCardNumber(res.data.billing_data[0].identity_card_number);
          setPassportNumber(res.data.billing_data[0].passport_number);
          setPersonalIdentificationNumber(
            res.data.billing_data[0].personal_identification_number
          );

          if (identityCardNumber.length > 0) {
            setIdDocumentation("identity_card_number");
          }
          if (personalIdentificationNumber.length > 0) {
            setIdDocumentation("personal_identification_number");
          }
          if (passportNumber.length > 0) {
            setIdDocumentation("passport_number");
          }
        }
        setLoading(true);
        setUpdateProfile(false);
      });
  }, [updateProfile]);

  const editBillingData = () => {
    axios
      .post(
        "https://6d76hzg376.execute-api.eu-north-1.amazonaws.com/update-billing",
        {
          first_name: firstName,
          last_name: lastName,
          date_of_birth: dateOfBirth,
          address: address,
          iban: iban,
          bic_swift: bicSwift,
          personal_identification_number: personalIdentificationNumber,
          passport_number: passportNumber,
          identity_card_number: identityCardNumber,
        },
        {
          headers: {
            Authorization: user.signInUserSession.idToken.jwtToken,
          },
        }
      )
      .then((res) => {
        setUpdateProfile(true);
        setStatus(200);
      });
  };

  return (
    <div style={{ width: "80%", padding: 20 }}>
      <Text color="dimmed">Personal or Company (B2B)</Text>
      <Select
        style={{ maxWidth: "35rem" }}
        placeholder="Personal or Company (B2B)"
        mt={5}
        mb={10}
        size="md"
        variant="filled"
        data={[
          { value: "personal", label: "Personal" },
          { value: "b2b", label: "Company" },
        ]}
        onChange={(event) => {
          setPersonalOrCompany(event);
        }}
        value={loading == true ? personalOrCompany : ""}
      />
      {personalOrCompany == "personal" ? (
        <>
          <div>
            <div style={{ display: matches ? "flex" : "block", maxWidth: "40rem", marginTop: 10 }}>
              <div style={{ display: "block", width: "100%" }}>
                <Text style={{ width: "15rem" }} color="dimmed">
                  First Name *
                </Text>
                <TextInput
                  icon={loading == true ? "" : <Loader size="xs" />}
                  required
                  style={{ width: "15rem" }}
                  mt={5}
                  mb={10}
                  size="md"
                  placeholder="John"
                  variant="filled"
                  value={loading == true ? firstName : ""}
                  onChange={(event) => {
                    setFirstName(event.currentTarget.value);
                    setChanges(true);
                  }}
                />
              </div>
              <div style={{ display: "block", width: "100%" }}>
                <Text style={{ width: "15rem" }} color="dimmed">
                  Last Name *
                </Text>
                <Input
                  icon={loading == true ? "" : <Loader size="xs" />}
                  required
                  style={{ width: "15rem" }}
                  mt={5}
                  mb={10}
                  placeholder="Smith"
                  variant="filled"
                  size="md"
                  value={loading == true ? lastName : ""}
                  onChange={(event) => {
                    setLastName(event.currentTarget.value);
                    setChanges(true);
                  }}
                />
              </div>
            </div>

            <div style={{ display: matches ? "flex" : "block", maxWidth: "40rem", marginTop: 10 }}>
              <div style={{ display: "block", width: "100%" }}>
                <Text style={{ width: "15rem" }} color="dimmed">
                  Date of Birth *
                </Text>
                <TextInput
                  icon={loading == true ? "" : <Loader size="xs" />}
                  required
                  style={{ width: "15rem" }}
                  mt={5}
                  mb={10}
                  variant="filled"
                  size="md"
                  placeholder="1992-04-10"
                  value={loading == true ? dateOfBirth : ""}
                  onChange={(event) => {
                    setDateOfBirth(event.currentTarget.value);
                    setChanges(true);
                  }}
                />
              </div>
              <div style={{ display: "block", width: "100%" }}>
                <Text style={{ width: "15rem" }} color="dimmed">
                  Address *
                </Text>
                <TextInput
                  icon={loading == true ? "" : <Loader size="xs" />}
                  required
                  style={{ width: "15rem" }}
                  placeholder="Old Street 57"
                  mt={5}
                  mb={10}
                  variant="filled"
                  size="md"
                  value={loading == true ? address : ""}
                  onChange={(event) => {
                    setAddress(event.currentTarget.value);
                    setChanges(true);
                  }}
                />
              </div>
            </div>

            <Text size={16} weight={500} mb={"0.5rem"} mt={"0.5rem"}>
              Bank Account Details
            </Text>

            <div style={{ display: matches ? "flex" : "block", maxWidth: "40rem" }}>
              <div style={{ display: "block", width: "100%" }}>
                <Text style={{ width: "15rem" }} color="dimmed">
                  IBAN *
                </Text>
                <TextInput
                  icon={loading == true ? "" : <Loader size="xs" />}
                  style={{ width: "15rem" }}
                  mt={5}
                  mb={10}
                  variant="filled"
                  size="md"
                  placeholder="SW123456789123456789"
                  value={loading == true ? iban : ""}
                  onChange={(event) => {
                    setIban(event.currentTarget.value);
                    setChanges(true);
                  }}
                />
              </div>
              <div style={{ display: "block", width: "100%" }}>
                <Text style={{ width: "15rem" }} color="dimmed">
                  Bank BIC / SWIFT code *
                </Text>
                <TextInput
                  style={{ width: "15rem" }}
                  icon={loading == true ? "" : <Loader size="xs" />}
                  placeholder="AAABBCC123"
                  mt={5}
                  mb={10}
                  variant="filled"
                  size="md"
                  value={loading == true ? bicSwift : ""}
                  onChange={(event) => {
                    setBicSwift(event.currentTarget.value);
                    setChanges(true);
                  }}
                />
              </div>
            </div>

            <Text size={16} weight={500} mb={"0.5rem"} mt={"0.5rem"}>
              Your Identity
            </Text>

            <div style={{ display: matches ? "flex" : "block", maxWidth: "40rem" }}>
              <div style={{ display: "block", width: "40rem"}}>
                <Text style={{ width: "15rem" }} color="dimmed">
                  Identification Document - Type *
                </Text>
                <Select
                  style={{ maxWidth: "15rem" }}
                  mt={5}
                  mb={10}
                  icon={loading == true ? "" : <Loader size="xs" />}
                  size="md"
                  variant="filled"
                  data={[
                    {
                      value: "personal_identification_number",
                      label: "Personal Identification Number",
                    },
                    { value: "passport_number", label: "Passport Number" },
                    {
                      value: "identity_card_number",
                      label: "Identity Card Number",
                    },
                  ]}
                  onChange={(event) => {
                    setIdDocumentation(event);
                    setChanges(true);
                  }}
                  value={loading == true ? idDocumentation : ""}
                />
              </div>
              <div style={{ display: "block", width: "100%" }}>
                {idDocumentation == "passport_number" ? (
                  <>
                    <Text style={{ width: "15rem" }} color="dimmed">
                      Passport Number *
                    </Text>
                    <TextInput
                      icon={loading == true ? "" : <Loader size="xs" />}
                      style={{ width: "15rem" }}
                      placeholder="ABC 123 456"
                      mt={5}
                      mb={10}
                      variant="filled"
                      size="md"
                      value={loading == true ? passportNumber : ""}
                      onChange={(event) => {
                        setPassportNumber(event.currentTarget.value);
                        setIdentityCardNumber("");
                        setPersonalIdentificationNumber("");
                        setChanges(true);
                      }}
                    />
                  </>
                ) : (
                  <div>
                    {" "}
                    {idDocumentation == "personal_identification_number" ? (
                      <>
                        <Text
                          style={{ width: "15rem" }}
                          color="dimmed"
                        >
                          Personal identification Number *
                        </Text>
                        <TextInput
                          style={{ width: "15rem" }}
                          icon={loading == true ? "" : <Loader size="xs" />}
                          placeholder="ABC 123 456"
                          mt={5}
                          mb={10}
                          variant="filled"
                          size="md"
                          value={
                            loading == true ? personalIdentificationNumber : ""
                          }
                          onChange={(event) => {
                            setPersonalIdentificationNumber(
                              event.currentTarget.value
                            );
                            setPassportNumber("");
                            setIdentityCardNumber("");
                            setChanges(true);
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <Text
                          style={{ width: "15rem" }}
                          color="dimmed"
                        >
                          Identity Card Number *
                        </Text>
                        <TextInput
                          icon={loading == true ? "" : <Loader size="xs" />}
                          style={{ width: "15rem" }}
                          placeholder="ABC 123 456"
                          mt={5}
                          mb={10}
                          variant="filled"
                          size="md"
                          value={loading == true ? identityCardNumber : ""}
                          onChange={(event) => {
                            setIdentityCardNumber(event.currentTarget.value);
                            setPersonalIdentificationNumber("");
                            setPassportNumber("");
                            setChanges(true);
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {changes == true ? 
          <Button
            mt={"0.5rem"}
            color={status == 200 ? "green" : "blue"}
            onClick={() => {
              editBillingData();
              setVisible((v) => !v);
            }}
          >
            {status == 200 ? (
              <div>Successfully Updated</div>
            ) : (
              <div>Update Billings</div>
            )}
          </Button>
          : <Button mt={"0.5rem"} disabled>Update Billings</Button>}
        </>
      ) : (
        <>
          <Text size={20} weight={500} mb={"0.5rem"} mt={"2rem"}>
            Invoice Data
          </Text>
          <Text weight={400} size={14} color="dimmed">
            Company Name:
          </Text>
          <Text weight={500}>Adly AB </Text>
          <Text weight={400} size={14} color="dimmed">
            Company Address:
          </Text>
          <Text weight={500}>Teknikringen 7</Text>
          <Text weight={400} size={14} color="dimmed">
            ZIP-Code:
          </Text>
          <Text weight={500}>583 30 Linköping </Text>
          <Text weight={400} size={14} color="dimmed">
            Organization Number:
          </Text>
          <Text weight={500}>559282-8239 </Text>
          <Text color="dimmed" mt={"1rem"}>
            Note: Invoice shall be sent after sponsorship has ended.
          </Text>
        </>
      )}
    </div>
  );
}

export default withAuthenticator(BillingsData);
